<template>
    <div>
        <el-dialog
            title="金融产品管理员"
            :visible.sync="showdialog"
            width="1200px"
            @close="back">

            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="公司">
                            <el-select v-model="form.company" placeholder="请选择金融产品公司" clearable filterable allow-create default-first-option>
                                <el-option v-for="(item, index) in companys"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input v-model="form.name" placeholder="请填写用户姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="form.telephone" placeholder="请填写用户手机号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm" icon="el-icon-search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <member-list  @getMember="getMember"></member-list>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="company" label="贷款公司" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="telephone" label="电话" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" show-overflow-tooltip align="center">
                            <template slot-scope="s">
                                <el-button type="danger" size="mini" @click="deleteuser(s.row)" icon="el-icon-delete">删除</el-button>
                                <el-button type="primary" size="mini" @click="edituser(s.row)" icon="el-icon-edit">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>

            <el-dialog
                title="编辑管理员信息"
                :visible.sync="showuserpicker"
                width="600px"
                append-to-body>

                <el-form :model="adminuser" ref="adminuser" label-width="80px" :inline="false" size="mini">
                    <el-form-item label="姓名">
                        <el-input v-model="adminuser.name" ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                            <el-input v-model="adminuser.telephone" placeholder="请填写用户手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="公司">
                        <el-select v-model="adminuser.company" placeholder="请选择金融产品公司" clearable filterable allow-create default-first-option>
                            <el-option v-for="(item, index) in companys"
                                :key="index"
                                :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="adduser">保存用户信息</el-button>
                    </el-form-item>
                </el-form>

            </el-dialog>

        </el-dialog>
    </div>
</template>

<script>
import MemberList from '../../../components/member-list.vue';
export default {
    components: {
        MemberList,
    },
    data() {
        return {
            showdialog: true,
            form: {
                name: '',
                telephone: '',
                company: '',
            },
            companys: [
                {name: '武汉沃昂信息科技有限公司'},
            ],
            tabledata: [],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            showuserpicker: false,
            adminuser: {
                name: '',
                telephone: '',
                company: '',
                uid: '',
                id: '',
            },
        }
    },
    mounted () {
        this.gettabledata();
    },
    methods: {
        adduser() {
            var params = {
                name: this.adminuser.name,
                telephone: this.adminuser.telephone,
                company: this.adminuser.company,
                uid: this.adminuser.uid,
                id: this.adminuser.id,
            }
            this.$api.editwelfareadminuserinfo(params).then(
                data=>{
                    this.$message.success(data);
                    this.gettabledata();
                    this.showuserpicker = false;
                }
            )
        },
        getMember(member) {
            console.log(member)
            var obj = {
                name: member.uname,
                telephone: member.telephone,
                company: '',
                uid: member.mid,
            }
            this.adminuser = obj;
            this.showuserpicker = true;
        },
        edituser(item) {
            this.adminuser = item;
            this.showuserpicker = true;
        },
        deleteuser(item) {
            this.$confirm('是否确定删除当前管理员')
                .then(_=>{
                    var params = {
                        id: item._id['$oid']
                    }
                    this.$api.deletewelfareamdinuser(params).then(
                        data=>{
                            this.$message.success(data);
                            this.gettabledata();
                        }
                    )
                })
        },
        back() {
            this.$router.go(-1);
        },
        confirm() {
            this.pageNo = 1;
            this.gettabledata();
        },
        gettabledata() {
            var params = {
                name: this.form.name,
                telephone: this.form.telephone,
                company: this.form.company,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.getwelfareadminuselist(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.gettabledata();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>